/* eslint-disable */
import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const RecordBarChart = ({labels,datasets,height=300,showLegend=true,barThickness=120,hoverLabel=true}) => {
  const data = {
    labels: labels,
        // datasets: datasets,
        datasets: datasets.map(ds => ({
        ...ds,
        barThickness: barThickness,         // fixed width of each bar
        borderRadius: 8,
    }))
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 20,   // <-- adds space below legend
      },
    },
    plugins: {
      legend: {
        display:showLegend,
        position: "bottom",
        labels: {
          font: {
            size: 10,
          },
          color: "#333",
          boxWidth: 20,
          boxHeight: 10,
        },
      },
      tooltip: {
        enabled: hoverLabel,
        callbacks: {
          title: () => "",
          label: (context) => `${context.label}: ${context.raw}`,
          // label: (context) => {
          //   const label = context.dataset.label || "";
          //   const value = context.raw;
          //   return `${label}: ${value}`;
          // }
        }
      },
      datalabels: {
      display: true,   // This hides the datas on the bars
      anchor: "end",
      align: "end",
      color: "#000",  // Change label color
      font: {
          size: 11,
          weight: "bold",
          family: "Roboto",
        },
      }
    },
  };

  return (
    <div style={{ width: "100%" , height: `${height}px`}}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default RecordBarChart;
